import state from './state'
import actions from './actions'

const keep = {
    namespaced: true,
    state,
    actions
}
export default keep